import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import BDetailsPage from "../../../components/crud/BDetailsPage";
import BErrorIndicator from "../../../components/indicators/BErrorIndicator";
import BLoadingIndicator from "../../../components/indicators/BLoadingIndicator";
import { authService } from "../../../service/authService";
import { usersService } from "../../../service/usersService";

const UsersDetails = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [user, setUser] = useState(null);
  const history = useHistory();
  const { id } = useParams();
  const [canMessages, setCanMessages] = useState();

  useEffect(() => {
    usersService
      .getUserById(id)
      .then((res) => setUser(res.data))
      .catch((err) => {
        if (err.response.status === 404) {
          history.push("/customers");
        }
        setError(true);
      });

    authService
      .getCurrentUser()
      .then((res) => setCanMessages(res.data.isAdmin || res.data.canMessages))
      .catch((err) => {
        if (err.response.status === 404) {
          history.push("/customers");
        }
        setError(true);
      })
      .finally((_) => {
        setIsLoading(false);
      });
  }, [id]);

  const handleDelete = () => {
    usersService.deleteUser(id).then(() => {
      history.push("/customers");
    });
  };

  const handleBlock = () => {
    usersService.blockUser(id).then(() => {
      history.push(`/customers`);
    });
  };

  const handleUnblock = () => {
    usersService.unblockUser(id).then(() => {
      history.push(`/customers`);
    });
  };

  if (isLoading) {
    return <BLoadingIndicator />;
  } else if (error) {
    return <BErrorIndicator />;
  }

  return (
    <BDetailsPage
      data={user}
      canMessages={canMessages}
      isUser="isUser"
      handleDelete={handleDelete}
      handleBlock={handleBlock}
      handleUnblock={handleUnblock}
      isBlocked={user?.isBlocked}
    />
  );
};

export default UsersDetails;
